import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';
import { HelpersService } from '@base/shared/services/helpers.service';

@Injectable()
export class ContractDefinitionsRequests {
  private config = environment;

  constructor(
    private http: AppHttpClient,
    private helpers: HelpersService
  ) {
  }

  /**
   * Get list of trades
   * @param contractId id of contract
   * @param payload request options
   */
  getTrades(contractId, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contractsDefinitions}/${contractId}/trades${query}`;
    return this.http.get(url);
  }

  /**
   * Get project settings list
   * @param contractId  id of contract
   * @param payload request options
   */
  getSettings(contractId, payload?) {
    const query = this.helpers.queryOptions(payload || {});
    const url = `${this.config.baseUrl}/v2/${this.config.services.contractDefinitions}/${contractId}/settings${query}`;
    return this.http.get(url);
  }

  /**
   * Toggle section value
   * @param contractId  id of contract
   * @param section section to be affected
   * @param payload request options
   */
  storeSectionToggle(contractId, section, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.contractDefinitions}/${contractId}/settings/daily_log_setup/${section}/toggle`;
    return this.http.post(url, payload);
  }
}
